










































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiPartenaire from '@/api/partenaire'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import CheckState from '@/components/shared/CheckState.vue'
import { toSubArray } from '@/utils/groupBy'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import { getDefaultAloFeedDownload } from '@/models/alo/AloFeedDownload'
import * as rules from '@/utils/validationRules'
//@ts-ignore
import VJsoneditor from 'v-jsoneditor/src/index'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'ModifyFeedDownloads', 
  props: {
    dldId:Number
  },
  components: { CheckState,VJsoneditor},
})

export default class ModifyFeedDownloads extends Vue {
  dldId!: number
  private showError = false    
  private loading = false
  private saving = false
  private modified = getDefaultAloFeedDownload()

  get feedDownload(){
    return this.$store.myGetters.feedDownloads[this.dldId] || getDefaultAloFeedDownload()
  }

  get json(){
    return JSON.parse(this.modified.dldJsonParam)
  }

  set json(newValue){
    this.modified.dldJsonParam = JSON.stringify(newValue)
  }

  get fluxList(){
    return this.$store.myGetters.fluxList
  }

  get partenaireList(){
    return this.$store.myGetters.partenaireList
  }

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  loadFeedDownload() {       
    if(this.dldId != 0) {
      this.loading = true
      this.$store.myActions.ADM_FEEDDOWNLOAD_DETAIL_REQUEST(this.dldId).then((feedDownload) =>{
        this.modified = {...getDefaultAloFeedDownload(), ...cloneDeep(feedDownload)}
      })
      .finally(() => {        
        this.loading = false
      })    
    }
  }

  get isDirty() {
    return !deepEqual(this.feedDownload,this.modified)
  }

  created(){
    this.$store.myActions.ADM_FLUX_ENSURE()
    this.$store.myActions.ADM_PARTENAIRE_ENSURE()
    this.loadFeedDownload()    
  }

  get arianeItems() {
    const arianeItems =  [
        {
          text: 'Data sources',
          disabled: false,          
          to: "/admin/feedDownloads",
          exact:true
        }
      ]
    if(this.feedDownload) {
        arianeItems.push({
          text: this.feedDownload.libelle,
          disabled: true,          
          to: "",
          exact:true
        })
    }
    return arianeItems;
  } 

  get feedDownloadsStatus() {
    return this.$store.myGetters.feedDownloadsStatus        
  }
  

  saveData() {
    if ((this.$refs.editFeedDownloadForm as HTMLFormElement).validate()) {
      this.saving = true       
      const redirect = this.modified.id != this.modified.newId
      this.$store.myActions.ADM_FEEDDOWNLOAD_SAVE_REQUEST(this.modified).then((savedSataSource:any) => {
        this.modified = cloneDeep(savedSataSource)
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.feedDownloadsStatus)                  
        if(redirect) this.$router.push({name:'ModifyFeedDownloads',params:{dldId:savedSataSource.id}})        
      }).finally(()=> {
        this.saving = false
      })    
    }
  }

  deleteFeedDownload(){
    if(this.dldId != 0) {      
       this.$confirm("Voulez vous vraiment supprimer ce feed download?",{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_FEEDDOWNLOAD_DELETE_REQUEST(this.dldId).then(() => {
            this.$router.push({name:'FeedDownloads'})
          })
        } 
      })          
    } 
  }

  cancelFeedDownload(){
    if(this.dldId == 0) this.modified = getDefaultAloFeedDownload()
    else this.loadFeedDownload()
  }

}
